export default "__VITE_ASSET__55a77c4b__"